import {
  productSettingsService,
  type ProductEmissionMode,
} from '@/services/product-settings';
import { PRODUCT_SETTINGS_QUERY_KEY } from '@/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Altera o modo de emissão de um produto.
 *
 * NÃO lança em erro de negócio — devolve o envelope `{ success, error }` para a
 * tela mostrar a mensagem sem perder o estado da linha.
 */
export function useUpdateProductEmissionMode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      productCode,
      emissionMode,
    }: {
      productCode: string;
      emissionMode: ProductEmissionMode;
    }) => productSettingsService.updateEmissionMode(productCode, emissionMode),
    onSuccess: response => {
      if (!response.success) return;
      queryClient.invalidateQueries({ queryKey: PRODUCT_SETTINGS_QUERY_KEY });
    },
  });
}
